/**
 * Centralized hub data source resolution.
 *
 * `REACT_APP_PAYLOAD_SOURCES` is a comma-separated list of hub module names
 * that should read from Payload CMS (e.g. `promotions,entertainment`). Any
 * module not listed falls back to the legacy ERS source.
 */

const PAYLOAD_SOURCES = new Set(
  (process.env.REACT_APP_PAYLOAD_SOURCES ?? "")
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean)
);

/**
 * @param {string} moduleName - e.g. `promotions`, `egd`, `entertainment`
 * @returns {'ers' | 'payload'}
 */
export function getHubSource(moduleName) {
  return PAYLOAD_SOURCES.has(String(moduleName).toLowerCase())
    ? "payload"
    : "ers";
}

/**
 * @param {string} moduleName - e.g. `promotions`, `egd`, `entertainment`
 * @returns {boolean}
 */
export function isPayloadSource(moduleName) {
  return getHubSource(moduleName) === "payload";
}
